export default {
  toasts: {
    failed_to_create_website: 'Eroare la crearea site-ului',
  },
  steps: {
    information: 'Informații',
    template: 'Șablon',
  },
  buttons: {
    next: 'Înainte',
    previous: 'Înapoi',
    create_website: 'Creează site',
    preview_about_us: 'Despre noi (previzualizare)',
  },
  about_us_modal: {
    title: 'Despre noi (previzualizare)',
  },
  error_messages: {
    missing_fields: 'Unele câmpuri obligatorii lipsesc. Completați toate informațiile necesare înainte de a continua.',
  },
};
